export const SET_HEADER_TITLE = 'SET_HEADER_TITLE'
export const OPEN_SIDE_NAV = 'OPEN_SIDE_NAV'
export const CLOSE_SIDE_NAV = 'CLOSE_SIDE_NAV'
export const TOGGLE_RIGHT_SIDENAV = 'TOGGLE_RIGHT_SIDENAV'
export const SET_SAVE_ALERT_ACTIONTYPE = 'SET_SAVE_ALERT_ACTIONTYPE'
